import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useSelector } from "react-redux"
import SurucuArayanlarContainer from "../../components/ilanlarContainers/SurucuArayanlarContainer"
import Btn from "../../components/shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { getDriverSeeker } from "../../features/ilanlar/ilanlarSlice"
import useWindowDimensions from "../../hooks/useWindowSize"
import SurucuArayanlarContainerMobile from "../../components/ilanlarContainers/SurucuArayanlarContainerMobile"
import InputSelectCity from "../../components/shared/input/new/InputSelectCity"
import { useState } from "react"
import Pagination from "../../components/shared/Pagination"

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            color: ${({ theme }) => theme.mainTextColor};
            .top-container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;
                gap: 20px;
                width: 100%;
            }
            .titles {
              width: 100%;
              display: grid;
              grid-template-columns:  repeat(8, 1fr);
              padding-inline: 10px;
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
                p{
                  text-align: center;
                }
            }
        }
    }
`
const titles = ["İlan No", "İlan Tarihi", "Telefon Numarası", "Çalışılacak İl", "Alınacak Sürücü Sayısı", "Maaş", "Diğer Yan Haklar", "Hafta Tatili"]


const SurucuArayanlar = () => {
  const {theme} = useSelector((state) => state.layout)
  const {driverSeekerList, driverSeekerCount} = useSelector((state) => state.ilanlar)
  const dispatch = useDispatch()
  const {windowDimensions} = useWindowDimensions()
  const [workCity, setWorkCity] = useState("")

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(driverSeekerCount / itemsPerPage);

  useEffect(() => {
    dispatch(getDriverSeeker({workCity: workCity, page: currentPage}))
  }, [workCity, currentPage])

  return (
    <Container>
      <PageTopTitle title={"Sürücü Arayanlar"} position='sticky'/>
      <div className="wrapper">
        <div className="content">
          <div className="top-container">
            <InputSelectCity data={workCity?.value} setData={setWorkCity} name={"workCity"} labelText={"Çalışılacak İl"} />

            <Btn handleClick={() => dispatch(showModal("addDriverSeeker"))} color="#E85446" bgColor="transparent" padding="10px" >İlan Ekle</Btn>
          </div>

          {windowDimensions?.width > 1150 &&
            <div className="titles">
              {titles.map((item) => (
                <p>{item}</p>
              ))}
            </div>
          }

          {windowDimensions?.width > 850 ? 
            driverSeekerList.map((item) => (
              <SurucuArayanlarContainer data={item} />
            ))
          :
            driverSeekerList.map((item) => (
              <SurucuArayanlarContainerMobile data={item} />
            ))
          }

{(driverSeekerList && driverSeekerList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
        </div>
      </div>
    </Container>
  )
}

export default SurucuArayanlar